export default {
  en: {
    TARGET_CONCURRENCY_ADVANCED_BUTTON: 'Advanced',
    TARGET_CONCURRENCY_BASIC_BUTTON: 'Basic',
  }
};